import { prefersReducedMotion } from '@theme/utilities';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductStickyNav extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    if (!prefersReducedMotion()) {
      this.#setIntersectionObserver();
    }

    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    if (!prefersReducedMotion()) {
      this.intersectionObserver?.disconnect();
    }

   document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;
    const newProductStickyNav = source.querySelector('product-sticky-nav');

    if (!newProductStickyNav) return;
    this.replaceWith(newProductStickyNav);
  }

  #setIntersectionObserver = () => {
    const productInformationContainer = document.querySelector('.product-information');

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('is-active');
          } else {
            this.classList.add('is-active');
          }
        });
      },
      { threshold: 0.4 }
    );

    this.intersectionObserver.observe(productInformationContainer);
  }
}

if (!customElements.get('product-sticky-nav')) {
  customElements.define('product-sticky-nav', ProductStickyNav);
}